import React, { FC, useMemo } from 'react';

import { noop } from 'lodash-es';

import { IItemOption, IItemOptionModifier } from '@rbi-ctg/menu';
import { ProductCard } from 'components/product-card';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';
import { useMenuContext } from 'state/menu';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { isItemOption } from 'utils/menu';

import { IModifierListItemProps } from './types';
import { getModifierImage, getModifierOptionImage } from './utils';

export const ModifierListItem: FC<IModifierListItemProps> = ({
  aspectRatio = 0.8,
  badgeContent,
  options,
  onOptionPress,
  content,
  isSelected = false,
  onListItemPress,
  selectedOption,
}) => {
  const { formatCalories } = useMenuCalories();
  const { selectedProduct, userSelections } = useProductWizardContext();
  const { slotKeyToCustomize } = useProductWizardFlow();
  const { priceForItemOptionModifier } = useMenuContext();

  const itemToCustomize = userSelections.comboSlot?.get(slotKeyToCustomize)?.selectedItem || null;

  const image = useMemo(
    () => (isItemOption(content) ? getModifierImage(content) : getModifierOptionImage(content)),
    [content]
  );

  const calories = useMemo(
    () =>
      isItemOption(content)
        ? formatCalories((selectedOption as IItemOptionModifier)?.nutrition?.calories)
        : formatCalories(content.nutrition?.calories),
    [content, formatCalories, selectedOption]
  );

  const price = priceForItemOptionModifier({
    item: itemToCustomize || selectedProduct,
    itemOption: content as IItemOption,
    modifier: selectedOption as IItemOptionModifier,
  });

  return (
    <ProductCard
      aspectRatio={aspectRatio}
      isSelected={isSelected}
      onProductPress={onListItemPress ? onListItemPress : noop}
      badgeContent={badgeContent}
      selectedOption={selectedOption}
      options={options}
      onOptionPress={onOptionPress ?? noop}
      productProps={{
        name: content.name?.locale,
        image,
        calories,
        price,
      }}
      imgObjectFitContain
    />
  );
};
